export default {
  pl: 3,
  pr: 5,
  py: 2,
};
